import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Fab from '@mui/material/Fab';
import { authPinPassword } from 'actions/EntityActions';
import DialogInput from 'screens/components/advanced/DialogInput';

class PinPadPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            dialogStatus: true
        };
        this.handlePin = this.handlePin.bind(this);
        this.deletePrevPinNumber = this.deletePrevPinNumber.bind(this);
        this.redirectHome = this.redirectHome.bind(this);
        this.validatePin = this.validatePin.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.onKey);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKey);
    }

    handlePin(e) {
        if (this.state.pin.length !== 4) {
            let pinNumber = e.target.textContent;
            this.setState(prevState => {
                return {
                    ...prevState,
                    pin: `${prevState.pin}${pinNumber}`

                };
            }, this.validatePin);
        }
    }

    deletePrevPinNumber() {
        if (this.state.pin.length !== 0) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    pin: prevState.pin.slice(0, -1)

                };
            });
        }
    }

    validatePin() {
        if (this.state.pin.length === 4) {
            let model = {
                branchId: this.props.branchId,
                pinPassword: this.state.pin,
                cashFlowId: this.props.cashFlow ? this.props.cashFlow.id : 0
            }

            this.props.authPinPassword(model);
            this.setState(prevState => {
                return {
                    ...prevState,
                    pin: ''
                };
            });
        }
    }

    redirectHome() {
        window.location = '/';
    }

    onKey = (e) => {
        if (e.keyCode === 8) {
            this.deletePrevPinNumber(); //delete key
        }
        if (!isNaN(Number(e.key)) && this.state.pin.length !== 4) {
            let pinNumber = e.key;
            this.setState(prevState => {
                return {
                    ...prevState,
                    pin: `${prevState.pin}${pinNumber}`

                };
            }, this.validatePin);
        }
    }

    render() {
        const { t } = this.props; 
        return (
            <DialogInput
                modal={true}
                open={this.state.dialogStatus}
                autoScrollBodyContent={true}
                className="passcode_dialog"
                style={{
                    width: `50%`
                }}
            >
                <div className="passcode_wrapper_pin modal-font-family">
                    <div className="pin-header">
                        <h3>{t('pos.pinpadPassword.enterPasscode')}</h3>
                        <div className="pincode-container d-flex justify-content-center">
                            <div className={`pincode ${this.state.pin.length > 0 ? 'pin-filled' : ''}`} />
                            <div className={`pincode ${this.state.pin.length > 1 ? 'pin-filled' : ''}`} />
                            <div className={`pincode ${this.state.pin.length > 2 ? 'pin-filled' : ''}`} />
                            <div className={`pincode ${this.state.pin.length > 3 ? 'pin-filled' : ''}`} />
                        </div>
                    </div>
                    <div className="d-flex  justify-content-center">
                        <Fab className="pin-buttons" onClick={this.handlePin}>1</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>2</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>3</Fab>
                    </div>
                    <div className="row text-center  justify-content-center">
                        <Fab className="pin-buttons" onClick={this.handlePin}>4</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>5</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>6</Fab>
                    </div>
                    <div className="row text-center  justify-content-center">
                        <Fab className="pin-buttons" onClick={this.handlePin}>7</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>8</Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>9</Fab>
                    </div>
                    <div className="row text-center  justify-content-center">
                        <Fab className="pin-buttons" onClick={this.deletePrevPinNumber}> &#8592; </Fab>
                        <Fab className="pin-buttons" onClick={this.handlePin}>0</Fab>
                        <Fab className="pin-buttons pin-cancel-btn" onClick={this.redirectHome}>{t('common.cancel')}</Fab>
                    </div>
                </div>
            </DialogInput>

        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        pinpadResponse: false,
        cashFlow: state.entity.cashFlow
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authPinPassword: (model) => dispatch(authPinPassword(model))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PinPadPassword));